/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CompetenceCompetenceidLangs200,
  GetApiV1CompetenceCompetenceidLangs401,
  GetApiV1CompetenceCompetenceidLangs404,
  GetApiV1CompetenceCompetenceidLangs500,
  GetApiV1CompetenceCompetenceidLangsPathParams,
  GetApiV1CompetenceCompetenceidLangsQueryParams,
  GetApiV1CompetenceCompetenceidLangsQueryResponse,
} from "../../types/competenceIdiomasController/GetApiV1CompetenceCompetenceidLangs.ts";
import { competenceLangViewModelPaginatedResponseSchema } from "../competenceLangViewModelPaginatedResponseSchema.ts";

export const getApiV1CompetenceCompetenceidLangsPathParamsSchema = z.object({
  competenceId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsPathParams>;

export const getApiV1CompetenceCompetenceidLangsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CompetenceCompetenceidLangs200Schema = z.lazy(
  () => competenceLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CompetenceCompetenceidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CompetenceCompetenceidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CompetenceCompetenceidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangs500>;

export const getApiV1CompetenceCompetenceidLangsQueryResponseSchema = z.lazy(
  () => getApiV1CompetenceCompetenceidLangs200Schema,
) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsQueryResponse>;
